import { FC, useState, useEffect } from 'react';
import { ActionType, Theme } from '../types/enums';
import { DynamicObjectInterface } from '../../../sdk/type';
import Menu from '../Menu/Menu';
import { FAIcon, IconStyle } from '../Icons';
import Table from '../Table/Table';
import { ColumnsInterface } from '../Table/types/propType';
import { TableWithActionProps } from './types/propTypes';
import styles from './TableWithAction.module.scss';

export const TableWithAction: FC<TableWithActionProps> = (props: TableWithActionProps) => {
  const {
    columns,
    dataSource,
    menuItems,
    rowKey,
    pagination = true,
    selected,
    theme = Theme.BLACK,
    paginationCallback,
    paginationObject,
    enableCheckbox = true,
    setSelectedKeys,
    actionColumnWidth = 10,
    onActionColumnClickCb = null,
    onRowClick,
    disabledItems,
    sortingCallback,
    actionType = ActionType.ELLIPSE_MENU,
    iconProps,
    // mlpVersion = MLPVersion.ONE,
    // pageSizeData,
    // scrollToTopRefId,
  } = props;
  const [tableColumns, setTableColumns] = useState(columns);
  const [activeMenuIndex, setActiveMenuIndex] = useState<number | null>(null);

  const handleClick = (index: number, rowObject: DynamicObjectInterface) => {
    setActiveMenuIndex(index);
    if (index != null && onActionColumnClickCb) {
      onActionColumnClickCb(rowObject, index);
    }
  };

  const menu = (
    <Menu
      menuItems={menuItems}
      onClose={() => {
        setActiveMenuIndex(null);
      }}
      className={styles['menu']}
    />
  );
  const action = (object: DynamicObjectInterface, index: number) => {
    const commonIconProps = {
      //theme: Theme.BLACK as IconTheme,
      //iconStyle: IconStyle.REGULAR,
    };

    switch (actionType) {
      case ActionType.SINGLE_ACTION_ICON:
        if (iconProps) {
          const iconStyle = iconProps[0]?.iconStyle === IconStyle.SOLID ?  IconStyle.SOLID : IconStyle.REGULAR;
          
          const isDisabled =
            typeof iconProps[0].isDisabled === 'function'
              ? iconProps[0].isDisabled(object)
              : iconProps[0].isDisabled ?? false;

          return (
            <FAIcon
              data-testid="first-icon-id"
              iconName={iconProps[0].iconName}
              iconStyle={iconStyle}
              theme={ isDisabled ? Theme.GRAY : Theme.BLACK}
              onClick={(event) => {
                if (!isDisabled) {
                  event.stopPropagation();
                  iconProps[0].onIconClick(object, index);
                }
              }}
              style={{
                pointerEvents: isDisabled ? 'none' : 'auto',
                opacity: isDisabled ? 0.3 : 1,
              }}
              //{...commonIconProps}
            />
          );
        }
        break;
      case ActionType.TWO_ACTION_ICON:
        if (iconProps) {
          
          const isDisabled =
            typeof iconProps[0].isDisabled === 'function'
              ? iconProps[0].isDisabled(object)
              : iconProps[0].isDisabled ?? false;

          const isDisabled1 =
            typeof iconProps[1].isDisabled === 'function'
              ? iconProps[1].isDisabled(object)
              : iconProps[1].isDisabled ?? false;

          return (
            <div className={styles['two-action-icon']}>
              <FAIcon
                data-testid="first-icon-id"
                iconName={iconProps[0].iconName}
                iconStyle={iconProps[0]?.iconStyle === IconStyle.SOLID ?  IconStyle.SOLID : IconStyle.REGULAR}
                className={styles['icon']}
                onClick={(event) => {
                  if (!isDisabled) {
                    event.stopPropagation();
                    iconProps[0].onIconClick(object, index);
                  }
                }}
                style={{
                  pointerEvents: isDisabled ? 'none' : 'auto',
                  opacity: isDisabled ? 0.3 : 1,
                }}
                {...commonIconProps}
              />
              <div className={styles['vertical-divider']}></div>
              <FAIcon
                data-testid="second-icon-id"
                iconName={iconProps[1].iconName}
                iconStyle={iconProps[1]?.iconStyle === IconStyle.SOLID ?  IconStyle.SOLID : IconStyle.REGULAR}
                className={styles['icon']}
                  onClick={(event) => {
                  if (!isDisabled1) {
                    event.stopPropagation();
                    iconProps[1].onIconClick(object, index);
                  }
                }}
                style={{
                  pointerEvents: isDisabled1 ? 'none' : 'auto',
                  opacity: isDisabled1 ? 0.3 : 1,
                }}
                {...commonIconProps}
              />
            </div>
          );
        }
        break;
      case ActionType.ELLIPSE_MENU:
      default:
        return (
          <button
            data-testid="table-data-test-action-button"
            className={styles['button']}
            onClick={(event) => {
              event.stopPropagation();
              handleClick(index, object);
            }}
          >
            ...
            {activeMenuIndex === index && menu}
          </button>
        );
    }
    return <></>;
  };
  useEffect(() => {
    setTableColumns((prevColumns: DynamicObjectInterface) => updateColumns(prevColumns));
  }, [columns, activeMenuIndex]);

  const updateColumns = (columns: ColumnsInterface[]) => {
    const updatedColumns = [...columns];
    const actionsColumnIndex = updatedColumns.findIndex((column) => column.key === 'actions');
    if (actionsColumnIndex !== -1) {
      updatedColumns.splice(actionsColumnIndex, 1);
    }
    updatedColumns.push({
      key: 'actions',
      width: actionColumnWidth,
      text: 'Actions',
      render: (object, index) => action(object, index),
    });
    return updatedColumns;
  };

  return (
    <Table
      columns={tableColumns}
      dataSource={dataSource}
      rowKey={rowKey}
      pagination={pagination}
      selected={selected}
      paginationCallback={paginationCallback}
      paginationObject={paginationObject}
      theme={theme}
      enableCheckbox={enableCheckbox}
      onRowClick={onRowClick}
      setSelectedKeys={setSelectedKeys}
      disabledItems={disabledItems}
      sortingCallback={sortingCallback}
      // adminPaginationStyle={AdminPaginationStyle.WITH_ALL_PAGES}
      //   mlpVersion={mlpVersion}
      //   pageSizeData={pageSizeData}
      //   scrollToTopRefId={scrollToTopRefId}
    />
  );
};

export default TableWithAction;
export { ActionType };
export type { TableWithActionProps, DynamicObjectInterface };
